var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.$style.index, 'wrapBox']},[_c('Download',{attrs:{"moreUrl":(_vm.appUrl + "/download"),"more-target":"_self"}}),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t('common.downloadList')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }